// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3a8AG","select":"Header_select__2m5l-","clinic":"Header_clinic__3A0CF"};